<script lang="ts">
  import { geheZu } from './router.svelte.ts';

  function navigiere(ereignis: MouseEvent, pfad: string): void {
    ereignis.preventDefault();
    geheZu(pfad);
  }
</script>

<footer class="fusszeile">
  <div class="breite fuss-grid">
    <div>
      <h3><span class="tb-wordmark">IT-Service Karsten Fischer</span></h3>
      <p class="leise-hell">Dein persönlicher IT-Service für Technik, Passwörter und Dokumente.</p>
      <p class="leise-hell">
        📞 <a href="tel:+4975683090137">+49 (0)7568 30 90 137</a><br />
        Mo–Sa 8:00–19:00 Uhr<br />
        ✉️ <a href="mailto:info@it-karsten-fischer.de">info@it-karsten-fischer.de</a>
      </p>
    </div>

    <div>
      <h3>Angebot</h3>
      <ul>
        <li><a href="/#leistungen">Technik-Support</a></li>
        <li><a href="/fernwartung" onclick={(e) => navigiere(e, '/fernwartung')}>Fernwartung starten</a></li>
        <li><a href="/#safes">Die Safes — Passwörter &amp; Unterlagen</a></li>
        <li><a href="/#preise">Preise</a></li>
        <li><a href="/ratgeber/">Ratgeber</a></li>
        <li><a href="/hilfe/">Anleitungen</a></li>
        <li><a href="https://portal.it-karsten-fischer.de">Kundenportal</a></li>
      </ul>
    </div>

    <div>
      <h3>Rechtliches</h3>
      <ul>
        <li><a href="/impressum" onclick={(e) => navigiere(e, '/impressum')}>Impressum</a></li>
        <li><a href="/datenschutz" onclick={(e) => navigiere(e, '/datenschutz')}>Datenschutzerklärung</a></li>
        <li><a href="/agb" onclick={(e) => navigiere(e, '/agb')}>AGB</a></li>
        <li><a href="/entgelte" onclick={(e) => navigiere(e, '/entgelte')}>Preis- und Leistungsverzeichnis</a></li>
        <li><a href="/widerruf" onclick={(e) => navigiere(e, '/widerruf')}>Widerruf</a></li>
      </ul>
    </div>
  </div>

  <div class="fuss-unten">
    <span>© 2026 IT-Service Karsten Fischer</span>
    <span>
      Martinshof 2, 88410 Bad Wurzach
      <a class="dl-link" href="/dl" onclick={(e) => navigiere(e, '/dl')} aria-label="Downloads">·</a>
    </span>
  </div>
</footer>

<style>
  .leise-hell {
    color: var(--tb-light-100);
  }

  /* Unauffälliger Zugang zu /dl: nur ein Pünktchen, keine Unterstreichung. */
  .dl-link {
    color: inherit;
    opacity: 0.5;
    text-decoration: none;
    padding: 0 0.4rem;
  }
</style>
